import React from 'react';
import { ShortWideBanner } from '../ShortWideBanner/index.js';

// import { relative } from 'path';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var LargeCenterImage = function (_a) {
    var _b;
    var image = _a.image, link = _a.link, LinkComponent = _a.LinkComponent, page = _a.page;
    return (React.createElement(ShortWideBanner, { image: image, link: link, LinkComponent: LinkComponent, fullWidth: !!((_b = page === null || page === void 0 ? void 0 : page.containerConfigOverride) === null || _b === void 0 ? void 0 : _b.width) }));
};

export { LargeCenterImage };
//# sourceMappingURL=index.js.map
